<template>
  <div>
    <apexchart
      v-if="series.length && antiguedades.length"
      :key="chartKey"
      type="bar"
      height="500"
      :options="chartOptions"
      :series="series"
    />
    <div v-else class="text-center p-4 text-grey">
      No hay datos de antigüedad disponibles
    </div>
  </div>
</template>

<script>
import ApexCharts from "vue-apexcharts";

export default {
  name: "GraphAntiquity",
  components: {
    apexchart: ApexCharts
  },
  props: {
    datos: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      chartKey: 0
    };
  },
  watch: {
    datos: {
      handler() {
        this.chartKey++;
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    formatNumber(value) {
      const number = Number(value);
      return number.toLocaleString('es-VE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  },
  computed: {
    // Tipos de cuenta (series)
    tiposCuenta() {
      if (!this.datos || !Array.isArray(this.datos)) return [];
      return [...new Set(this.datos.map(d => d.tipo_cuenta).filter(Boolean))];
    },

    // Antigüedades (eje X)
    antiguedades() {
      if (!this.datos || !Array.isArray(this.datos)) return [];
      return [...new Set(this.datos.map(d => d.antiguedad).filter(Boolean))];
    },

    // Series para ApexCharts
    series() {
      if (!this.datos || !Array.isArray(this.datos)) return [];
      return this.tiposCuenta.map(tipo => ({
        name: tipo,
        data: this.antiguedades.map(ant => {
          const item = this.datos.find(
            d => d.tipo_cuenta === tipo && d.antiguedad === ant
          );
          return item ? (Number(item.deuda_total) || 0) : 0;
        })
      }));
    },

    chartOptions() {
      return {
        chart: {
          type: 'bar',
          stacked: true,
          toolbar: { show: true }
        },
        xaxis: {
          categories: this.antiguedades,
          title: { text: "Antigüedad" }
        },
        yaxis: {
          labels: {
            formatter: val => "$" + this.formatNumber(val)
          },
          title: { text: "Deuda Total" }
        },
        tooltip: {
          y: {
            formatter: val => "$" + this.formatNumber(val)
          }
        },
        plotOptions: {
          bar: { horizontal: false }
        },
        legend: {
          position: "right",
          offsetY: 40
        },
        dataLabels: {
          enabled: false
        }
      };
    }
  }
};
</script>

